import { useCallback as e } from "react";
import { useTranslation as t } from "react-i18next";
import { VerificationStatus as n } from "@maat/api-main/types";
//#region src/enums/useTrIdentityHoldNotice.ts
var r = () => {
	let { t: r } = t("booking");
	return e((e, t) => {
		let i = {
			[n.Unverified]: "unverified",
			[n.Pending]: "pending",
			[n.Rejected]: "rejected",
			[n.Verified]: "unverified"
		}, a = {
			[n.Unverified]: "checkout.identity.actions.verify",
			[n.Pending]: "checkout.identity.actions.viewStatus",
			[n.Rejected]: "checkout.identity.actions.retry",
			[n.Verified]: "checkout.identity.actions.verify"
		};
		return {
			title: r(`checkout.identity.held.${i[e]}.title`),
			body: r(`checkout.identity.held.${i[e]}.body`, { time: t }),
			action: r(a[e])
		};
	}, [r]);
};
//#endregion
export { r as useTrIdentityHoldNotice };
